import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getTodaysConsults,
  getPastsConsults,
  acceptAConsult,
  getFacilityFilter,
} from '../services/consultsService';
import type { AcceptResponse } from '../services/consultsService';
import { REFRESH_INTERVAL } from '@qler-view/shared_lib/src/shared/constants/CommanConstants';

export const useGetTodaysConsults = (userId: number) => {
  const { data, isLoading, isError, error, refetch, isPending } = useQuery({
    queryKey: ['consultList', userId],
    staleTime: 0,
    gcTime: 0,
    refetchInterval: REFRESH_INTERVAL,
    queryFn: async () => {
      const data = await getTodaysConsults(userId);
      return data;
    },
  });
  return {
    todaysConsults: data,
    isLoading,
    isError,
    isPending,
    error,
    refetch,
  };
};

export const useGetPastsConsults = (userId: number) => {
  const { data, isLoading, isError, error, isPending } = useQuery({
    queryKey: ['pastConsultList', userId],
    staleTime: 0,
    refetchInterval: REFRESH_INTERVAL,
    gcTime: 0,
    queryFn: async () => {
      const data = await getPastsConsults(userId);
      return data;
    },
  });
  return {
    pastsConsults: data,
    isLoading,
    isError,
    isPending,
    error,
  };
};
export const useGetFacilityFilter = (userId: number) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['facilityFilter', userId],
    queryFn: async () => {
      const data = await getFacilityFilter(userId);
      return data;
    },
  });
  return {
    facilityFilter: data,
    isLoading,
    isError,
    error,
  };
};

export const useAcceptConsult = (userId: number, refetch: () => void) => {
  const queryClient = useQueryClient();

  return useMutation<
    AcceptResponse,
    { status: number; message: string },
    // { code: number; status: string; message: string }, // Error type
    { userId: number; caseId: number } // Arguments type
  >({
    mutationFn: async ({ userId, caseId }) => {
      const data = await acceptAConsult(userId, caseId);
      console.log('data', data);
      return data;
    },
    onSuccess: (data) => {
      console.log('Consult accepted successfully:', data);

      // Invalidate all queries related to today's consults
      queryClient.invalidateQueries({
        queryKey: ['todaysConsultList', userId],
      });
      refetch();
    },
    onError: (error) => {
      console.error('Error accepting consult:', error);
    },
  });
};
